import React, { useRef, useEffect } from "react";
import { ELEVENLABS_STATUS } from "./elevenLabsStatus";

// Icono circular del asistente de voz, siempre alcanzable en VR vía hud-follow:
// sigue el yaw (giro horizontal) de la cámara e ignora el pitch, así queda
// siempre delante del usuario sin importar el ambiente o hacia dónde gire,
// y no "se escapa" cuando mira hacia abajo para gatillar el fuse. Un ícono
// fijo a la cámara no se puede targetear (reticle y ícono giran igual) y un
// punto fijo en el mundo se pierde al mirar para otro lado.
// IMPORTANTE: sin offset lateral (x). El gaze reticle apunta siempre al
// centro de la vista; cualquier offset en x hace que el ícono se recalcule
// cada frame a esa misma distancia del yaw actual, así que "perseguirlo"
// girando la cabeza nunca converge. Solo se puede offsetear en altura (y),
// porque el pitch de la cámara sí cambia el reticle y permite alcanzarlo.
export default function ElevenLabsVR({ status, onToggle }) {
  const config = ELEVENLABS_STATUS[status] || ELEVENLABS_STATUS.idle;
  const clickElRef = useRef(null);

  useEffect(() => {
    const el = clickElRef.current;
    if (!el) return;
    el.addEventListener("click", onToggle);
    return () => el.removeEventListener("click", onToggle);
  }, [onToggle]);

  return (
    <a-entity hud-follow="distance: 2.5; height: -0.35; tilt: 15">
      {/* halo pulsante detrás del ícono: llama la atención tipo "hacé click acá" */}
      <a-entity
        geometry="primitive: ring; radiusInner: 0.19; radiusOuter: 0.26"
        material="shader: flat; color: #E94E1B; opacity: 0.45; transparent: true; side: double"
        position="0 0 -0.015"
        animation__halo_scale="property: scale; from: 1 1 1; to: 1.5 1.5 1.5; dir: alternate; dur: 1100; loop: true; easing: easeInOutSine"
        animation__halo_fade="property: material.opacity; from: 0.45; to: 0.05; dir: alternate; dur: 1100; loop: true; easing: easeInOutSine"
      ></a-entity>
      <a-entity
        ref={clickElRef}
        class="interactable objeto"
        geometry="primitive: circle; radius: 0.16"
        material={`shader: flat; color: ${config.color}; opacity: 0.92; transparent: true; side: double`}
        animation__breathe={
          status !== "connected"
            ? "property: scale; to: 1.08 1.08 1.08; dir: alternate; dur: 900; loop: true; easing: easeInOutSine"
            : ""
        }
        animation__pulso={
          status === "connected"
            ? "property: scale; to: 1.15 1.15 1.15; dir: alternate; dur: 700; loop: true; easing: easeInOutSine"
            : ""
        }
        animation__fusing="property: scale; to: 1.25 1.25 1.25; dur: 900; startEvents: fusing; easing: easeOutQuad"
      >
        <a-image
          src="#phoneIcon"
          geometry="primitive: circle; radius: 0.12"
          material="shader: flat; transparent: true"
          position="0 0 0.01"
        ></a-image>
      </a-entity>
    </a-entity>
  );
}
